import BaseHttpService from "./BaseHttpService";
import {
  AuthApiService,
  UtilsApiService,
  CalculationsApiSerivce,
  SavedItemsApiService,
  RawMaterialsApiService,
  UsersService,
  ContactUsApiService,
  SolutionApiService,
} from "./ApiServices";
import MockHttpService from "./MockHttpService";
import Config from "../../Configs";
import { CFPService } from "./ApiServices/CFPService";
import { PdfService } from "./ApiServices/PdfService";

const httpService = Config.useMockData ? new MockHttpService() : new BaseHttpService();

const Api = {
  Auth: new AuthApiService(httpService),
  Utils: new UtilsApiService(httpService),
  Calculations: new CalculationsApiSerivce(httpService),
  SavedItems: new SavedItemsApiService(httpService),
  RawMaterials: new RawMaterialsApiService(httpService),
  Users: new UsersService(httpService),
  setUserIdentifier: (userIdentifier: string) => httpService.setUserIdentifier(userIdentifier),
  ContactUs: new ContactUsApiService(httpService),
  Solution: new SolutionApiService(httpService),
  CFP: new CFPService(httpService),
  PdfService: new PdfService(httpService),
};

export default Api;
